import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
} from '@mui/material';
import { formatOffset } from './formatOffset';

type DeleteEffectRegistrationTimeOptionDialogProps = {
  minutes: number | undefined;
  isDeleting: boolean;
  onClose: () => void;
  onDelete: (minutes: number, cascade: boolean) => void;
};

const DeleteEffectRegistrationTimeOptionDialog: React.FC<DeleteEffectRegistrationTimeOptionDialogProps> = (props) => {
  const { minutes, isDeleting, onClose, onDelete } = props;
  const [alsoRemoveIfCreatedOnChainConfig, setAlsoRemoveIfCreatedOnChainConfig] = useState(true);

  return (
    <Dialog
      open={minutes !== undefined}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      slotProps={{ transition: { onExited: () => setAlsoRemoveIfCreatedOnChainConfig(true) } }}
    >
      <DialogTitle>Delete evaluation time option?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {minutes !== undefined ? formatOffset(minutes) : ''} will no longer be available as an evaluation time option.
        </DialogContentText>
        <FormControlLabel
          sx={{ mt: 2 }}
          control={
            <Checkbox
              checked={alsoRemoveIfCreatedOnChainConfig}
              onChange={(e) => setAlsoRemoveIfCreatedOnChainConfig(e.target.checked)}
            />
          }
          label="Also remove from prescription chains that already had this option before it became a customer option"
        />
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          color="error"
          disabled={isDeleting || minutes === undefined}
          onClick={() => minutes !== undefined && onDelete(minutes, alsoRemoveIfCreatedOnChainConfig)}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteEffectRegistrationTimeOptionDialog;
